var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardShuffleBefore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x2: 301.58,
    x1: 119.259,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.987861 -0.188483 0.172273 1.02815 -15.5846 -50.2915)",
    y2: 653.112,
    y1: 383.376,
    id: "LinearGradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115702,
    stopColor: "#b053bc"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#680c83",
    offset: 0.838843
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.987861 -0.188483 0.172273 1.02815 -15.5846 -50.2915)",
    id: "LinearGradient_2",
    x2: 301.58,
    y1: 383.376,
    gradientUnits: "userSpaceOnUse",
    x1: 119.259,
    y2: 653.112
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103306,
    stopColor: "#ffb3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828512,
    stopColor: "#c07086"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LinearGradient_3",
    y1: 383.376,
    y2: 653.112,
    gradientTransform: "matrix(1.00357 0.0157269 -0.0163628 1.04415 321.278 -120.186)",
    x2: 301.58,
    x1: 119.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115702,
    stopColor: "#b053bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838843,
    stopColor: "#680c83"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LinearGradient_4",
    y2: 653.112,
    gradientTransform: "matrix(1.00357 0.0157269 -0.0163628 1.04415 321.278 -120.186)",
    y1: 383.376,
    x2: 301.58,
    gradientUnits: "userSpaceOnUse",
    x1: 119.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103306,
    stopColor: "#b3d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7087c0",
    offset: 0.836777
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 523.806,
    x2: 925.756,
    id: "LinearGradient_5",
    y1: 523.806,
    gradientTransform: "matrix(0.966245 0.282926 -0.264542 1.00729 127.073 -277.443)",
    x1: 680.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115702,
    stopColor: "#b053bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838843,
    stopColor: "#680c83"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    y1: 391.594,
    x2: 882.094,
    y2: 645.218,
    id: "LinearGradient_6",
    gradientTransform: "matrix(0.966245 0.282926 -0.264542 1.00729 127.073 -277.443)",
    gradientUnits: "userSpaceOnUse",
    x1: 724.624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.072314,
    stopColor: "#b3ffce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836777,
    stopColor: "#70c092"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M235.943+351.658C235.277+351.325+233.943+349.913+233.943+350.658C233.943+351.86+235.277+352.658+235.943+353.658",
    opacity: 1,
    fill: "#f5ebed"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#LinearGradient)",
    d: "M138.365+283.379L351.047+242.8C359.231+241.238+366.923+246.283+368.227+254.066L426.171+599.886C427.476+607.67+421.899+615.246+413.715+616.808L201.032+657.387C192.849+658.949+185.157+653.904+183.853+646.121L125.908+300.301C124.604+292.517+130.181+284.941+138.365+283.379Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.365+283.379L351.047+242.8C359.231+241.238+366.923+246.283+368.227+254.066L426.171+599.886C427.476+607.67+421.899+615.246+413.715+616.808L201.032+657.387C192.849+658.949+185.157+653.904+183.853+646.121L125.908+300.301C124.604+292.517+130.181+284.941+138.365+283.379Z",
    opacity: 1,
    fill: "url(#LinearGradient_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.154+303.802L335.563+270.715C342.235+269.442+348.549+273.809+349.665+280.47L399.244+576.366C400.36+583.027+395.856+589.458+389.183+590.731L215.774+623.817C209.102+625.09+202.788+620.723+201.672+614.063L152.093+318.166C150.977+311.506+155.481+305.075+162.154+303.802Z",
    opacity: 1,
    fill: "#f5ebed"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.12+357.035C259.753+371.979+261.163+386.677+262.957+401.699C264.173+411.876+266.496+422.215+267.35+432.403C267.607+435.465+266.673+438.552+266.942+441.613C268.604+460.532+275.615+477.882+279.612+496.243C283.783+515.407+286.444+535.032+289.847+554.349",
    opacity: 1,
    fill: "#f5ebed"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M257.12+357.035C258.8+366.904+260.076+376.821+261.233+386.764C261.911+392.59+262.498+398.432+263.282+404.246C264.32+411.951+265.878+419.58+266.818+427.298C267.084+429.477+267.442+431.737+267.392+433.936C267.344+435.993+266.92+438.023+266.892+440.081C266.854+442.92+267.368+445.84+267.8+448.639C270.298+464.836+276.087+480.276+279.612+496.243C283.85+515.445+286.54+534.975+289.847+554.349L289.847+554.349L289.847+554.349C286.54+534.975+283.85+515.445+279.612+496.243C276.087+480.276+270.298+464.836+267.8+448.639C267.368+445.84+266.854+442.92+266.892+440.081C266.92+438.023+267.344+435.993+267.392+433.936C267.442+431.737+267.084+429.477+266.818+427.298C265.878+419.58+264.32+411.951+263.282+404.246C262.498+398.432+261.911+392.59+261.233+386.764C260.076+376.821+258.8+366.904+257.12+357.035L257.12+357.035Z",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#f5ebed",
    d: "M289.265+562.575L285.79+560.14L285.444+558.171L287.413+557.824L287.413+557.824"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5ebed",
    strokeLinejoin: "round",
    strokeWidth: 20,
    opacity: 1,
    d: "M245.526+372.931L263.782+356.249L283.853+463.644L291.597+505.077",
    stroke: "#d18296",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d18296",
    strokeWidth: 20,
    opacity: 1,
    strokeLinecap: "round",
    fill: "#f5ebed",
    d: "M266.675+513.775L317.067+505.856",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "url(#LinearGradient_3)",
    d: "M412.194+238.599L628.26+241.985C636.573+242.115+643.213+248.629+643.089+256.534L637.585+607.736C637.461+615.641+630.621+621.943+622.307+621.813L406.241+618.427C397.927+618.297+391.288+611.783+391.412+603.878L396.916+252.676C397.04+244.771+403.88+238.469+412.194+238.599Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.194+238.599L628.26+241.985C636.573+242.115+643.213+248.629+643.089+256.534L637.585+607.736C637.461+615.641+630.621+621.943+622.307+621.813L406.241+618.427C397.927+618.297+391.288+611.783+391.412+603.878L396.916+252.676C397.04+244.771+403.88+238.469+412.194+238.599Z",
    opacity: 1,
    fill: "url(#LinearGradient_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.859+263.477L608.026+266.238C614.805+266.344+620.214+271.914+620.108+278.677L615.399+579.179C615.293+585.943+609.712+591.34+602.933+591.234L426.766+588.473C419.987+588.367+414.578+582.798+414.684+576.034L419.393+275.532C419.499+268.768+425.08+263.371+431.859+263.477Z",
    opacity: 1,
    fill: "#ebeff5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M475.648+385.393C475.648+385.393+507.984+312.319+552.935+372.537C582.376+418.736+479.117+488.31+479.117+488.31L560.364+493.1",
    strokeWidth: 20,
    opacity: 1,
    fill: "none",
    stroke: "#7b93ca",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "url(#LinearGradient_5)",
    d: "M708.605+263.736L916.634+324.649C924.639+326.993+929.504+335.075+927.501+342.701L838.522+681.506C836.519+689.132+828.407+693.414+820.402+691.071L612.373+630.158C604.368+627.814+599.503+619.732+601.506+612.106L690.485+273.3C692.488+265.674+700.6+261.392+708.605+263.736Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#LinearGradient_6)",
    opacity: 1,
    d: "M708.605+263.736L916.634+324.649C924.639+326.993+929.504+335.075+927.501+342.701L838.522+681.506C836.519+689.132+828.407+693.414+820.402+691.071L612.373+630.158C604.368+627.814+599.503+619.732+601.506+612.106L690.485+273.3C692.488+265.674+700.6+261.392+708.605+263.736Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf5f1",
    d: "M721.686+293.086L891.3+342.751C897.827+344.662+901.728+351.501+900.015+358.026L823.881+647.92C822.167+654.446+815.487+658.186+808.96+656.275L639.346+606.61C632.819+604.699+628.918+597.86+630.632+591.335L706.766+301.44C708.479+294.915+715.159+291.175+721.686+293.086Z",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    opacity: 1,
    stroke: "#86d5a6",
    d: "M743.43+403.803C743.43+403.803+821.513+385.106+807.565+444.143C799.074+480.085+748.86+464.512+748.86+464.512C748.86+464.512+794.061+479.772+794.142+503.665C794.224+527.558+755.271+577.462+711.879+514.639",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 20
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardShuffleBefore);
export default __webpack_public_path__ + "static/media/cardShuffleBefore.082d960264be6c0cab2379151b1325ab.svg";
export { ForwardRef as ReactComponent };